import React from 'react';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatBps, normalizeHistorySeries } from '../lib/routerMonitoringFormatters';

const RouterTrafficChart = ({ historySamples = [], title = 'Riwayat Trafik' }) => {
  const data = normalizeHistorySeries(historySamples);
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="text-sm font-semibold uppercase tracking-[0.12em] text-cyan-200">{title}</h3>
      {data.length === 0 ? (
        <p className="mt-2 text-sm text-slate-500">Belum ada data riwayat trafik.</p>
      ) : (
        <div className="mt-3 h-72 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
              <XAxis dataKey="label" stroke="#94a3b8" minTickGap={16} />
              <YAxis stroke="#94a3b8" tickFormatter={(v) => formatBps(v)} />
              <Tooltip formatter={(v) => formatBps(v)} />
              <Legend />
              <Line type="monotone" dataKey="in_bps" name="In bps" stroke="#38bdf8" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="out_bps" name="Out bps" stroke="#34d399" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default RouterTrafficChart;
